import { stringify } from 'query-string';
import { useCallback, useMemo } from 'react';
import { useLocation } from 'react-router';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { parseQueryString } from '../../../common/QueryStringHelper';
const useQueryParams = (querySettings) => {
    const { pathname, search } = useLocation();
    const history = useNavigate();
    const { formatQuery, query } = useMemo(() => parseQueryString(search, querySettings), [search, querySettings]);
    /**
     * 並び順の更新
     * @type {(function(*): void)|*}
     */
    const onClickSort = useCallback((e) => {
        const newSort = e.currentTarget.value;
        if (!newSort) {
            return;
        }
        let newOrder;
        if (formatQuery.order === 'desc') {
            // 同じsortが存在する場合はorderを反転
            newOrder = 'asc';
        }
        else {
            newOrder = 'desc';
        }
        const newQuery = stringify(Object.assign(Object.assign({}, query), { order: newOrder, page: 1, sort: newSort }));
        history.replace(`${pathname}?${newQuery}`);
    }, [history, pathname, query, formatQuery.order]);
    /**
     * ページの更新
     */
    const onPageChange = useCallback(({ selected }) => {
        const newQuery = stringify(Object.assign(Object.assign({}, query), { page: selected + 1 }));
        history.push(`${pathname}?${newQuery}`);
    }, [history, query, pathname]);
    /**
     * 検索ワードの更新
     */
    const onBlurKeyword = useCallback((e) => {
        const searchText = e.currentTarget.value;
        const newQuery = stringify(Object.assign(Object.assign({}, query), { searchText }));
        history.replace(`${pathname}?${newQuery}`);
    }, [history, pathname, query]);
    return {
        formatQuery,
        onBlurKeyword,
        onClickSort,
        onPageChange,
        pathname,
        query,
    };
};
export const useMyPageRouter = {
    useQueryParams,
};
export default useMyPageRouter;
